import { Platform } from 'react-native';
import type { Edge } from 'react-native-safe-area-context';

/**
 * Mobile: el inset superior lo reserva AppTabHeader (tabs) o el header nativo del ShellStack.
 * No aplicar `top` en el contenedor raíz o el gap superior se duplica.
 * Web: mantener `top` por si hay inset de PWA / notch en el navegador.
 */
export function appRootSafeAreaEdges(): Edge[] {
  return Platform.OS === 'web' ? ['top', 'left', 'right'] : ['left', 'right'];
}
